module.exports = __webpack_public_path__ + "img/gemini.e0d178ad.svg";